import {Component, signal, inject} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {NbButtonModule, NbSpinnerModule, NbToastrService} from "@nebular/theme";
import {Title} from "@angular/platform-browser";
import {AuthService} from "../../services/auth.service";
import {notificationsParams} from "../../shared/settings";
import {TranslateModule, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-validate-my-account',
  standalone: true,
  imports: [
    TranslateModule,
    NbButtonModule,
    NbSpinnerModule
  ],
  templateUrl: './validate-my-account.component.html',
  styleUrl: './validate-my-account.component.scss'
})
export class ValidateMyAccountComponent {
  private readonly translate = inject(TranslateService);
  currentTitle: string;
  loading = signal<boolean>(false);
  private token: string = '';

  constructor(private readonly title: Title, private toastrService: NbToastrService,
              private route: ActivatedRoute, private authService: AuthService) {
    this.currentTitle = this.title.getTitle();
    this.token = this.route.snapshot.queryParams['token'];
  }

  ngOnInit() {}

  confirmAccount() {
    this.loading.set(true);
    this.authService.confirmAccount(this.token).subscribe({
      next: (response: any) => {
        this.loading.set(false);
        this.toastrService.success(this.translate.instant('validate_account.validated'), this.translate.instant('common.information'), notificationsParams);
        window.location.assign(`/auth/login?username=${response.username}`);
      },
      error: (err: any) => {
        this.toastrService.danger(this.translate.instant('validate_account.failed'), this.translate.instant('common.error'), notificationsParams);
        this.loading.set(false);
      }
    });
  }
}
